import { render, staticRenderFns } from "./PlanProjectOriginChart.vue?vue&type=template&id=f9f99ac4&scoped=true&"
import script from "./PlanProjectOriginChart.vue?vue&type=script&lang=js&"
export * from "./PlanProjectOriginChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f99ac4",
  null
  
)

export default component.exports